import { prepareRequest } from './request'
import { logger } from '../utils'
import { BONUS_TYPE, BONUS_STATUS } from '../constants'

export const getAvailableBonuses = ({
  currency = 'AUD',
  language = 'ENG',
  country = 'Australia',
  signal = null
}) => {
  logger.debug('BonusService.getAvailableBonuses', { country, currency, language })
  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/bonus:search',
    signal
  })
  return request({ country, currency, language })
}

export const getActiveBonuses = ({
  language = 'ENG',
  bonusTypes = [
    BONUS_TYPE.DEPOSIT,
    BONUS_TYPE.RELOAD_DEPOSIT,
    BONUS_TYPE.FREEBET_DEPOSIT
  ],
  paging = {
    currentPage: 0,
    itemsPerPage: 100
  },
  signal = null
}) => {
  logger.debug('BonusService.getActiveBonuses', { language, bonusTypes, paging })

  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bonus:search',
    signal
  })

  return request({ language, bonusTypes, paging })
}

export const splitFreeBetOptions = ({ freeBetId, signal = null }) => {
  logger.debug('BonusService.splitFreeBetOptions', { freeBetId })

  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bonus:split-options',
    signal
  })

  return request({ id: freeBetId })
}

export const splitFreeBet = ({ freeBetId, splitId, signal = null }) => {
  logger.debug('BonusService.splitFreeBet', { freeBetId, splitId })

  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bonus:split',
    signal
  })

  return request({ id: freeBetId, splitId })
}

export const activateBonus = (id, signal = null) => {
  logger.debug('BonusService.activateBonus', id)

  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bonus:activate',
    signal
  })

  return request({ id })
}

export const cancelBonus = (id, signal = null) => {
  logger.debug('BonusService.cancelBonus', id)

  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bonus:cancel',
    signal
  })

  return request({ id })
}

export const getAvailableBundles = ({
  language = 'ENG',
  status = [BONUS_STATUS.AVAILABLE],
  paging = {
    currentPage: 0,
    itemsPerPage: 100
  },
  signal = null
}) => {
  logger.debug('BonusService.getActiveBundles', { language, status, paging })
  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bundle:search',
    signal
  })
  return request({
    filter: {
      status
    },
    language,
    paging
  })
}

export const activateBundle = (id, signal = null) => {
  logger.debug('BonusService.activateBundle', { id })
  const request = prepareRequest({
    method: 'POST',
    url: 'bonus-service/client-bundle:activate',
    signal
  })
  return request({ id })
}
